<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Marketplace Store Management <small class="text-muted">stores</small>
                      </h4>
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col">
                      <div class="form-group row">
                        <label for="courier_id" class="col-sm-2 col-form-label">{{ $t('marketplace.marketplace_name') }}</label>
                        <div class="col-sm-4">
                          <select class="form-control" v-model="marketplaceStore.marketplace_id">
                            <option :value="marketplaceStore.marketplace_id">{{ marketplaceStore.marketplace_id }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="store_account" class="col-sm-2 col-form-label">{{ $t('marketplace.store.store_account') }}</label>
                        <div class="col-sm-3">
                          <input v-model="marketplaceStore.store_account" type="text" name="store_account" class="form-control">
                        </div>
                        <label for="store_name" class="col-sm-2 col-form-label">{{ $t('marketplace.store.store_name') }}</label>
                        <div class="col-sm-3">
                          <input v-model="marketplaceStore.store_name" type="text" name="store_name" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="store_user_id" class="col-sm-2 col-form-label">{{ $t('marketplace.store.store_user_id') }}</label>
                        <div class="col-sm-3">
                          <input v-model="marketplaceStore.store_user_id" type="text" name="store_user_id" class="form-control" />
                        </div>
                        <label for="store_token" class="col-sm-2 col-form-label">{{ $t('marketplace.store.store_token') }}</label>
                        <div class="col-sm-3">
                          <input v-model="marketplaceStore.store_token" type="text" name="store_token" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="store_email" class="col-sm-2 col-form-label">{{ $t('marketplace.store.store_email') }}</label>
                        <div class="col-sm-3">
                          <input v-model="marketplaceStore.store_email" type="text" name="store_email" class="form-control" />
                        </div>
                        <label for="store_currency" class="col-sm-2 col-form-label">{{ $t('marketplace.store.store_currency') }}</label>
                        <div class="col-sm-3">
                          <input v-model="marketplaceStore.store_currency" type="text" name="store_currency" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="service_url" class="col-sm-2 col-form-label">{{ $t('marketplace.store.service_url') }}</label>
                        <div class="col-sm-6">
                          <input v-model="marketplaceStore.service_url" type="text" name="service_url" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="time_schedule" class="col-sm-2 col-form-label">{{ $t('marketplace.store.time_schedule') }}</label>
                        <div class="col-sm-3">
                          <select v-model="marketplaceStore.time_schedule" name="time_schedule" class="form-control">
                            <option value="all">All</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="debug" class="col-sm-2 col-form-label">{{ $t('marketplace.store.debug') }}</label>
                        <div class="col-sm-3">
                          <select v-model="marketplaceStore.debug" name="debug" class="form-control">
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="remark" class="col-sm-2 col-form-label">{{ $t('marketplace.store.remark') }}</label>
                        <div class="col-sm-6">
                          <input v-model="marketplaceStore.remark" type="text" name="remark" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="status" class="col-sm-2 col-form-label">{{ $t('marketplace.store.status') }}</label>
                        <div class="col-sm-8">
                          <CSwitch class="mx-1" :checked.sync="status" color="primary" variant="outline" shape="pill"/>
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->

              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> {{ $t('marketplace.store.update') }}</b-button>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'StoreEdit',
  components: {
    loadingPanel
  },
  mounted () {
    this.axios.get('/marketplace/store/' + this.$route.params.id).then(response => {
      this.marketplaceStore = response.data
      if (this.marketplaceStore.status === 1) {
        this.status = true
      }
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      couriers: [],
      marketplaceStore: {
        id: '',
        marketplace_id: '',
        store_account: '',
        store_name: '',
        store_user_id: '',
        store_token: '',
        store_email: '',
        store_currency: '',
        service_url: '',
        time_schedule: '',
        debug: '',
        remark: '',
        status: 0
      },
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      status: false,
      message: ''
    }
  },
  methods: {
    handleSubmit () {
      if (this.marketplaceStore.store_account) {
        // create store
        this.getMarketplaceStoreStatus()
        this.showLoadingPanel = true
        this.axios.put('/marketplace/store/' + this.marketplaceStore.id, this.marketplaceStore).then(response => {
          this.showLoadingPanel = false
          this.showAlert('success', this.$t('marketplace.store.success_message'))
          this.message = response.data
        }).catch(error => {
          this.showLoadingPanel = false
          this.showAlert('danger', error.data.message)
        })
      }
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    },
    getMarketplaceStoreStatus () {
      if (this.status) {
        this.marketplaceStore.status = 1
      } else {
        this.marketplaceStore.status = 0
      }
    }
  }
}
</script>
